import { IadditionalServiceDataForToolLogistics } from '../../../types/product.configuration.types';
import NudosAdditionalServiceStatus from './NudosAdditionalServiceStatus/NudosAdditionalServiceStatus';
import './NudosToolAdditionalServices.scss';

const NudosToolAdditionalServices = ({
  styling,
  additionalServicesOrConfigurationsData
}: {
  styling: 'toolDetails' | 'logisticServiceDetails' | 'toolHistoryCardAdditionalServices';
  additionalServicesOrConfigurationsData: IadditionalServiceDataForToolLogistics[];
}) => {
  if (!additionalServicesOrConfigurationsData?.length) return <></>;
  const isAppleConfiguration = additionalServicesOrConfigurationsData.some(item => (item.configData?.length ?? 0) > 0);
  return (
    <div className={`nudosToolAdditionalServices ${styling}`}>
      {additionalServicesOrConfigurationsData.map(additionalService => {
        return (
          <NudosAdditionalServiceStatus
            key={`${additionalService.name}-${additionalService.id}`}
            additionalServiceData={additionalService}
            isAdditionalSettingsInOrders={isAppleConfiguration}
          />
        );
      })}
    </div>
  );
};

export default NudosToolAdditionalServices;
